//================================================================================
export class BaseCredentials {
  accountName: string;
  password: string;

  constructor() {
    this.accountName = '';
    this.password = '';
  }
}

// mappano le classi dichiarate in ..\provisioning-admin\server\Controllers\Helpers\Credentials.cs
//================================================================================
export class Credentials extends BaseCredentials {
  AppId: string;
  SubscriptionKey: string;
  Token: string;

  constructor() {
    super();
    this.AppId = 'CC'; //todo identificativo della cloudconsole come da registered app???!!!
    this.SubscriptionKey = '';
    this.Token = '';
  }
}

//================================================================================
export class DeveloperCredentials extends BaseCredentials {
  InstallationPath: string;
  MachineName: string;
  Port: string;

  constructor() {
    super();
    this.InstallationPath = '';
    this.MachineName = '';
    this.Port = '';
  }
}

//================================================================================
export class DatabaseCredentials {
  Provider: string;
  Server: string;
  Database: string;
  Login: string;
  Password: string;

  constructor() {
    this.Provider = '';
    this.Server = '';
    this.Database = '';
    this.Login = '';
    this.Password = '';
  }
}

//================================================================================
export class ChangePasswordInfo {
  AccountName: string;
  Password: string;
  JWTToken: string;
  NewPassword: string;
  IgnoreOldPassword: boolean;

  constructor() {
    this.AccountName = '';
    this.Password = '';
    this.JWTToken = '';
    this.NewPassword = '';
    this.IgnoreOldPassword = false;
  }
}

//================================================================================
export class GwamToken {
  token: string;
  constructor() {
    this.token = '';
  }
}
